import useId from '../utils/useId';
import * as React from 'react';
export const nayapaySvg = React.forwardRef(function nayapaySvgInner(
  props,
  ref,
) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  const id_2 = baseId + '_2';
  const id_3 = baseId + '_3';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.93 7.113c-.8-1.365-2.497-3.11-4.87-3.11-7.292.085-12.432 6-12.039 11.829v-.21c0-2.323 1.955-4.094 3.173-4.783.91-.504 2.287-.91 4.328-1.07 1.451-.11 4.833.308 4.833.308.725-.012 5.472.824 5.41 6.025.812-4.808-.024-7.624-.836-8.989Z',
      fill: `url(#bi_nayapay__a_${id_0})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.06 4.015c2.373 0 4.058 1.746 4.87 3.11.798 1.366 1.635 4.17.835 8.953 0 .012-.012.086-.012.098-.16 2.041-1.439 3.579-2.472 4.23-.209.11-1.414 1.033-3.615.972 4.894.787 7.772.037 9.161-.75C26.217 19.84 28 18.18 28 15.844c-.099-7.107-6.038-12.15-11.94-11.83Z',
      fill: `url(#bi_nayapay__b_${id_1})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.637 24.378c-.246-.357-.332-.885-.356-1.205a1.395 1.395 0 0 1-.037-.307v-7.157c0-.086.012-.32.012-.345 0-.049.025-.307.025-.32a5.596 5.596 0 0 1 1.168-2.803c.024-.024.049-.061.074-.086l.037-.037c.38-.455.799-.824 1.18-1.057h.012a4.04 4.04 0 0 1 .381-.234c.542-.32 1.624-.8 3.222-.75-4.894-.787-7.771-.012-9.16.774-1.403.787-3.174 2.448-3.174 4.784.087 6.837 5.596 11.743 11.264 11.83-2.127-.259-3.91-1.833-4.648-3.087Z',
      fill: `url(#bi_nayapay__c_${id_2})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M24.827 20.615c-1.39.787-4.267 1.55-9.16.75h.024l-.468-.037c-1.524-.098-3.332-.295-4.98 1.55 0 .037.012.96.381 1.5.8 1.365 2.853 3.111 5.227 3.111 6.812-.086 11.755-5.25 12.038-10.686-.393 1.82-1.869 3.136-3.062 3.812Z',
      fill: `url(#bi_nayapay__d_${id_3})`,
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_nayapay__a_${id_0}`,
          x1: 7.153,
          y1: 10.052,
          x2: 20.942,
          y2: 10.052,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#F28920',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.859,
          stopColor: '#ED463C',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_nayapay__b_${id_1}`,
          x1: 20.452,
          y1: 7.355,
          x2: 21.966,
          y2: 19.346,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#F28920',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.859,
          stopColor: '#ED463C',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_nayapay__c_${id_2}`,
          x1: 9.328,
          y1: 22.928,
          x2: 11.055,
          y2: 14.411,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#F28920',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.859,
          stopColor: '#ED463C',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_nayapay__d_${id_3}`,
          x1: 19.061,
          y1: 19.884,
          x2: 19.828,
          y2: 25.962,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#F28920',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.859,
          stopColor: '#ED463C',
        }),
      ),
    ),
  );
});
nayapaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var nayapay = {
  category: 'brand',
  colorable: false,
  name: 'nayapay',
  svg: nayapaySvg,
};
